import React, { useState, useEffect, useRef, useMemo } from 'react';
import CommonCheckbox from '../../../../common/components/CommonCheckBox/CommonCheckbox';
import { useFormikContext } from 'formik';
import {
  itrDocUpload,
  UploadFileToS3,
  itrDocUploaded,
  saveOtherIncome,
  getOtherIncomes
} from '../../../../common/constants/api';
import initialImg from '../../../../images/icons/upload_new.svg';
import GlobalUploadComp from '../../../../common/components/GlobalUploadComp/GlobalUploadComp';
import { FindSubset } from '../../../../common/constants/FindSubset';
import { useEffectDepChange } from '../../../../hooks/useEffectDepChange';
import { getApplicantionInfo } from '../../../../common/utils/applicantionInfo';
import { ShowGetImage } from '../../../../common/components/ShowGetImage/ShowGetImage';
import InputTypeNumber from '../../../../common/components/InputTypeNumber/InputTypeNumber';
import PopUp from '../../../../common/components/PopUp/PopUp';

const OtherIncomes_Salaried = () => {
  const [showFullImage, setShowFullImage] = useState(false);
  const [isItrValid, setIsItrValid] = useState(false);
  const [isRentUploaded, setIsRentUploaded] = useState(false);
  const [isCashUploaded, setIsCashUploaded] = useState(false);
  const [otherDocUploads, setOtherDocUploads] = useState({});
  const [leadAppicant_Id, setLeadApplicant_Id] = useState('');
  const [lead_Id, setLead_id] = useState('');
  const [loading, setLoading] = useState(false);
  const [showError, setShowError] = useState('');
  const [show, setShow] = useState(true);
  const [docUploaded, setDocUploaded] = useState(false);
  const [docUploadError, setDocUploadError] = useState(false);
  const [submitError, setSubmitError] = useState('');
  const [edit0, setEdit0] = useState(false);
  const [edit1, setEdit1] = useState(false);
  const [edit2, setEdit2] = useState(false);
  const [edit3, setEdit3] = useState(false);
  const [itrDocs, setItrDoc] = useState([]);
  const [itrDocId, setItrDocId] = useState({});
  const [cashDoc, setCashDoc] = useState('');
  const [cashDocId, setCashDocId] = useState('');
  let dep = [];

  const {
    values: data,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
    setFieldValue,
    setFieldTouched,
    setFieldError,
    validateForm,
    resetForm
  } = useFormikContext();

  // get api
  useEffect(() => {
    if (lead_Id && leadAppicant_Id) {
      getOtherIncomes(lead_Id, leadAppicant_Id)
        .then(res => {
          if (res) {
            setFieldValue('intFromDeposit', res.interestFromDeposit);
            setFieldValue('bankInt', res.bankInterest);
            setFieldValue('rentalIncome', res.rentalIncome);
            setFieldValue('agriIncome', res.agriIncome);
            setFieldValue('divident', res.dividend);
            setFieldValue('totalRentCollected', res?.totalRentCollected);
            data?.hasOwnProperty('cash') && setFieldValue('cash', res?.cash);
          }

          let temp = [];
          let temp2 = {};
          if (res.itrDocLinks.length > 0)
            res.itrDocLinks.map(el => {
              if (el.tag === 'itr-1') {
                temp2 = { ...temp2, second: el.docId };
                temp[1] = el.url;
              }
              if (el.tag === 'itr-0') {
                temp2 = { ...temp2, first: el.docId };
                temp[0] = el.url;
              }
            });
          if (res.rentalDocLink?.url || false) {
            temp2 = { ...temp2, rental: res.rentalDocLink?.docId };
            temp[2] = res.rentalDocLink.url;
          }
          if (res.cashDocLink?.url) {
            setCashDoc(res?.cashDocLink?.url);
            setCashDocId(res?.cashDocLink?.docId);
          }
          setItrDoc([...temp]);
          setItrDocId(temp2);
        })
        .catch(err => {});
    }
    return () => {
      setItrDoc([]);
      setItrDocId({});
      setCashDoc('');
      setCashDocId('');
    };
  }, [lead_Id, leadAppicant_Id]);

  // fetching the leadDetails
  useEffect(() => {
    let leadDetails = getApplicantionInfo();
    const { leadId, leadApplicantId } = leadDetails;
    setLead_id(leadId);
    setLeadApplicant_Id(leadApplicantId);
    return () => {
      data.file = [];
      data.imgUrl = [];
    };
  }, []);

  const validationFields = [data.file[0], data.file[1]];
  const fileUploader = async index => {
    setShow(true);
    setLoading(true);
    setDocUploaded(false);
    setDocUploadError(false);
    let docId, url;
    await itrDocUpload(lead_Id, leadAppicant_Id, 'itr', `itr-${index}`)
      .then(res => {
        docId = res.requestId;
        if (index === 0) {
          setItrDocId({ ...itrDocId, first: parseInt(docId) });
        }
        if (index === 1) {
          setItrDocId({ ...itrDocId, second: parseInt(docId) });
        }
        url = res.url;
        UploadFileToS3(url, data.file[index][0], {
          'Content-Type': `${data.file[index][0].type}`
        })
          .then(res => {
            itrDocUploaded(lead_Id, leadAppicant_Id, docId, 'itr')
              .then(res => {
                setDocUploaded(true);
                setOtherDocUploads({
                  ...otherDocUploads,
                  index: 'uploaded'
                });
              })
              .catch(err => {
                setDocUploadError(true);
              });
          })
          .catch(err => {
            setDocUploadError(true);
          });
      })
      .catch(err => {
        setDocUploadError(true);
      });
  };

  dep = useEffectDepChange({ ...validationFields });

  // making the code easy

  useEffect(() => {
    if (dep?.length > 0 || false) {
      let depInx = dep[0][0];
      if (depInx == 0) {
        fileUploader(0);
      } else if (depInx == 1) {
        fileUploader(1);
      } else fileUploader(2);
    }
  }, [dep]);

  useEffect(() => {
    if (
      (data.file[0] && data.file[0] !== '') ||
      (data.file[1] && data.file[1] !== '')
    ) {
      setIsItrValid(true);
    } else setIsItrValid(false);
  }, [...validationFields]);

  useEffect(() => {
    if (data.file[2] && data.file[2] !== '') {
      setShow(true);
      setLoading(true);
      setDocUploaded(false);
      setDocUploadError(false);
      let docId, url;
      itrDocUpload(lead_Id, leadAppicant_Id, 'rental')
        .then(res => {
          docId = res.requestId;
          setItrDocId({ ...itrDocId, rental: parseInt(docId) });
          url = res.url;
          UploadFileToS3(url, data.file[2][0], {
            'Content-Type': `${data.file[2][0].type}`
          })
            .then(res => {
              itrDocUploaded(lead_Id, leadAppicant_Id, docId, 'rental')
                .then(res => {
                  setDocUploaded(true);
                  setIsRentUploaded(true);
                  setOtherDocUploads({
                    ...otherDocUploads,
                    2: 'uploaded'
                  });
                })
                .catch(err => {
                  setIsRentUploaded(false);
                  setDocUploadError(true);
                });
            })
            .catch(err => {
              setIsRentUploaded(false);
              setDocUploadError(true);
            });
        })
        .catch(err => {
          setIsRentUploaded(false);
          setDocUploadError(true);
        });
    }
  }, [data.file[2]]);

  // lets upload cash doc

  useEffect(() => {
    if (data.file[3] && data.file[3] !== '') {
      setShow(true);
      setLoading(true);
      setDocUploaded(false);
      setDocUploadError(false);
      let docId, url;
      itrDocUpload(lead_Id, leadAppicant_Id, 'cash')
        .then(res => {
          let docId = res?.requestId;
          setCashDocId(docId);
          UploadFileToS3(res?.url, data.file[3][0], {
            'Content-Type': `${data.file[3][0].type}`
          })
            .then(res => {
              itrDocUploaded(lead_Id, leadAppicant_Id, docId, 'cash')
                .then(res => {
                  setDocUploaded(true);
                  setIsCashUploaded(true);
                  setOtherDocUploads({
                    ...otherDocUploads,
                    3: 'uploaded'
                  });
                })
                .catch(err => {
                  setIsCashUploaded(true);
                  setDocUploadError(true);
                });
            })
            .catch(err => {
              setIsCashUploaded(true);
              setDocUploadError(true);
            });
        })
        .catch(err => {
          setIsCashUploaded(true);
          setDocUploadError(true);
        });
    }
  }, [data.file[3]]);

  //funcs to show popUps
  const applyCondtn = () => {
    if (docUploaded || docUploadError || loading) return true;
  };
  useEffect(() => {
    if (docUploadError || docUploaded) setLoading(false);
  }, [docUploaded, docUploadError]);

  const propsRenderer = () => {
    let props = {};
    if (docUploaded) {
      props.type = 'success';
      props.text = 'Document uploaded successfully';
      props.autoClose = true;
      return props;
    }

    if (docUploadError) {
      props.type = 'fail';
      props.text = 'Error uploading the file, please try again ';
      props.autoClose = true;
      return props;
    }

    if (loading) {
      props.type = 'loading';
      props.text = 'Uploading document. . . ';
      return props;
    }
  };

  const onSubmitHandler = () => {
    let temp1 = Object.assign({}, itrDocId),
      temp2;

    if (
      data.intFromDeposit ||
      data.bankInt ||
      data.rentalIncome ||
      data.agriIncome ||
      data.divident ||
      data.cash
    ) {
      delete temp1.rental;

      temp2 = Object.values(temp1);
    }
    saveOtherIncome(lead_Id, leadAppicant_Id, {
      interestFromDeposit: data.intFromDeposit,
      bankInterest: data.bankInt,
      rentalIncome: data.rentalIncome,
      agriIncome: data.agriIncome,
      dividend: data.divident,
      cash: data.cash,
      ...((data.intFromDeposit ||
        data.bankInt ||
        data.rentalIncome ||
        data.agriIncome ||
        data.agriIncome ||
        data.cash ||
        data.divident) && { itrDocIds: temp2 }),
      ...(data.rentalIncome && {
        rentalAgreementDocId: itrDocId.rental,
        totalRentCollected: data?.totalRentCollected
      }),
      ...(data.cash && {
        cashDocId: parseInt(cashDocId)
      })
    })
      .then(res => {
        handleSubmit();
      })
      .catch(err =>
        setSubmitError(
          err?.response?.data?.message ||
            'something gone wrong!please try again..'
        )
      );
  };

  return (
    <>
      {applyCondtn() && (
        <PopUp {...propsRenderer()} setShow={setShow} show={show} />
      )}
      <div id="outerCon" className=" relative pb-12 ">
        <p className="font-normal font-roboto text-black-100 text-base ml-12">
          Other Income
        </p>

        <div className="flex flex-col flex-start ml-12 content-around">
          <div className="inline-flex my-2 ">
            <CommonCheckbox
              checked={data?.intFromDeposit || false}
              name="intFromDeposit"
              value={data.intFromDeposit}
              onChange={e => {
                setFieldValue('intFromDeposit', e.target.checked, true);
                setFieldTouched('intFromDeposit', true, false);
              }}
              onBlur={handleBlur}
            />
            <p className="text-black-500 ">
              Interest from deposit (FD/Post Office etc)
            </p>
          </div>
          {/* bank Interest */}
          <div className="inline-flex my-2">
            <CommonCheckbox
              checked={data?.bankInt || false}
              name="bankInt"
              value={data.bankInt}
              onChange={e => {
                setFieldValue('bankInt', e.target.checked, true);
                setFieldTouched('bankInt', true, false);
              }}
              onBlur={handleBlur}
            />
            <p className="text-black-500 ">Bank Interest</p>
          </div>
          {/* rental agreement */}
          <div className="inline-flex my-2">
            <CommonCheckbox
              checked={data?.rentalIncome || false}
              name="rentalIncome"
              value={data.rentalIncome}
              onChange={e => {
                setFieldValue('rentalIncome', e.target.checked, true);
                setFieldTouched('rentalIncome', true, false);
              }}
              onBlur={handleBlur}
            />
            <p className="text-black-500 ">Rental Income</p>
          </div>
          {/* agriculture income */}
          <div className="inline-flex my-2">
            <CommonCheckbox
              checked={data?.agriIncome || false}
              name="agriIncome"
              value={data.agriIncome}
              onChange={e => {
                setFieldValue('agriIncome', e.target.checked, true);
                setFieldTouched('agriIncome', true, false);
              }}
              onBlur={handleBlur}
            />
            <p className="text-black-500 ">Agriculture Income </p>
          </div>
          {/* Dividend */}
          <div className="inline-flex my-2">
            <CommonCheckbox
              checked={data?.divident || false}
              name="divident"
              value={data.divident}
              onChange={e => {
                setFieldValue('divident', e.target.checked, true);
                setFieldTouched('divident', true, false);
              }}
              onBlur={handleBlur}
            />
            <p className="text-black-500 ">Dividend</p>
          </div>
          {/* cash */}
          {data?.hasOwnProperty('cash') && (
            <div className="inline-flex my-2">
              <CommonCheckbox
                checked={data?.cash || false}
                name="cash"
                value={data?.cash}
                onChange={e => {
                  setFieldValue('cash', e.target.checked, true);
                  setFieldTouched('cash', true, false);
                }}
                onBlur={handleBlur}
              />
              <p className="text-black-500 ">Cash</p>
            </div>
          )}
        </div>

        {/* ITR UPLOAD */}
        {data.intFromDeposit ||
        data.bankInt ||
        data.rentalIncome ||
        data.agriIncome ||
        data.cash ||
        data.divident ? (
          <div className="mt-6">
            <p className="font-roboto font-normal text-sm ml-12 mb-1 text-black-200 ">
              Please upload last 2 years ITR
            </p>
            <div className="flex flex-row flex-wrap flex-start ml-12 ">
              <div className="m-2 ">
                {itrDocs[0] && !edit0 ? (
                  <div className="ml-2 mt-4">
                    <ShowGetImage img={itrDocs[0]} setEdit={setEdit0} />
                  </div>
                ) : (
                  <GlobalUploadComp
                    data={data}
                    imgIndex={0} //0,1,2,3 depending upon the no of file sequence
                    errors={errors}
                    touched={touched}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    setFieldValue={setFieldValue}
                    setFieldTouched={setFieldTouched}
                    setFieldError={setFieldError}
                    showFullImage={showFullImage} // boolean , to change mobile upload image view
                    initialImg={initialImg} // initial image
                    subInst="Click here to upload"
                    subtext="CHOOSE FILE"
                    resetForm={resetForm}
                  />
                )}
              </div>
              <div className="m-2">
                {itrDocs[1] && !edit1 ? (
                  <div className="ml-2 mt-4">
                    <ShowGetImage img={itrDocs[1]} setEdit={setEdit1} />
                  </div>
                ) : (
                  <GlobalUploadComp
                    data={data}
                    imgIndex={1} //0,1,2,3 depending upon the no of file sequence
                    errors={errors}
                    touched={touched}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    setFieldValue={setFieldValue}
                    setFieldTouched={setFieldTouched}
                    setFieldError={setFieldError}
                    showFullImage={showFullImage} // boolean , to change mobile upload image view
                    initialImg={initialImg} // initial image
                    subInst="Click here to upload"
                    subtext="CHOOSE FILE"
                    resetForm={resetForm}
                  />
                )}
              </div>
            </div>
          </div>
        ) : null}
        {data?.rentalIncome ? (
          <div className="mt-4">
            <p className="font-roboto font-normal text-sm ml-12 mb-2 text-black-200 ">
              Rent Agreement
            </p>
            <div className="flex justify-start ml-12 pl-2 mx-auto">
              {itrDocs[2] && !edit2 ? (
                <div className="ml-2 mt-4 ">
                  <ShowGetImage img={itrDocs[2]} setEdit={setEdit2} />
                </div>
              ) : (
                <GlobalUploadComp
                  data={data}
                  imgIndex={2} //0,1,2,3 depending upon the no of file sequence
                  errors={errors}
                  touched={touched}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  setFieldValue={setFieldValue}
                  setFieldTouched={setFieldTouched}
                  setFieldError={setFieldError}
                  showFullImage={showFullImage} // boolean , to change mobile upload image view
                  initialImg={initialImg} // initial image
                  subInst="Click here to upload"
                  subtext="CHOOSE FILE"
                  resetForm={resetForm}
                />
              )}
            </div>
            <div className="w-full flex my-8 ml-12 pl-2 flex items-center">
              <div className="w-full ">
                <InputTypeNumber
                  name="totalRentCollected"
                  maxLength={7}
                  minLength={0}
                  legendName={'Total Rent Collected'}
                  value={data.totalRentCollected}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  disabled={false}
                  error={
                    touched.totalRentCollected && errors.totalRentCollected
                  }
                  errorMsg={errors.totalRentCollected}
                  touched={touched.totalRentCollected}
                  setFieldValue={setFieldValue}
                  setFieldTouched={setFieldTouched}
                  setFieldError={setFieldError}
                />
              </div>
            </div>
          </div>
        ) : null}
        {/* Cash Documents upload */}
        {data?.cash ? (
          <div className="mt-6">
            <p className="font-roboto font-normal text-sm ml-12 mb-1 text-black-200 ">
              Please upload your cash income document
            </p>
            <div className="flex flex-row flex-wrap flex-start ml-12 ">
              <div className="m-2 ">
                {cashDoc && !edit3 ? (
                  <div className="ml-2 mt-4">
                    <ShowGetImage img={cashDoc} setEdit={setEdit3} />
                  </div>
                ) : (
                  <GlobalUploadComp
                    data={data}
                    imgIndex={3} //0,1,2,3 depending upon the no of file sequence
                    errors={errors}
                    touched={touched}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    setFieldValue={setFieldValue}
                    setFieldTouched={setFieldTouched}
                    setFieldError={setFieldError}
                    showFullImage={showFullImage} // boolean , to change mobile upload image view
                    initialImg={initialImg} // initial image
                    subInst="Upload cash document"
                    subtext="CHOOSE FILE"
                    resetForm={resetForm}
                  />
                )}
              </div>
            </div>
          </div>
        ) : null}
      </div>
      <div className="mt-5 ">
        <button
          type="button"
          onClick={onSubmitHandler}
          disabled={
            itrDocs.length === 0
              ? !isItrValid ||
                (data?.rentalIncome && !isRentUploaded) ||
                (data?.cash && !isCashUploaded && !cashDoc)
              : false
          }
          className=" submitButton text-14 w-56 h-12 font-medium  font-roboto"
        >
          next
        </button>
      </div>
      {submitError ? (
        <p className="font-roboto font-normal text-center text-base break-words text-red-100 w-full mt-5">
          {submitError}
        </p>
      ) : null}
    </>
  );
};
export default OtherIncomes_Salaried;
